import { render, staticRenderFns } from "./productPatient.vue?vue&type=template&id=6a7450a2&scoped=true"
import script from "./productPatient.vue?vue&type=script&lang=js"
export * from "./productPatient.vue?vue&type=script&lang=js"
import style0 from "./productPatient.vue?vue&type=style&index=0&id=6a7450a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7450a2",
  null
  
)

export default component.exports